{
    "lightLevels": {
        "lava": 15,
        "brown_mushroom": 1,
        "torch": 14,
        "wall_torch": 14,
        "fire": 15,
        "soul_fire": 10,
        "soul_torch": 10,
        "soul_wall_torch": 10,
        "glowstone": 15,
        "nether_portal": 11,
        "jack_o_lantern": 15,
        "enchanting_table": 7,
        "brewing_stand": 1,
        "lava_cauldron": 15,
        "end_portal": 15,
        "end_portal_frame": 1,
        "dragon_egg": 1,
        "ender_chest": 7,
        "beacon": 15,
        "sea_lantern": 15,
        "end_rod": 14,
        "end_gateway": 15,
        "magma_block": 3,
        "conduit": 15,
        "lantern": 15,
        "soul_lantern": 10,
        "shroomlight": 15,
        "crying_obsidian": 10,
        "amethyst_cluster": 5,
        "large_amethyst_bud": 4,
        "medium_amethyst_bud": 2,
        "small_amethyst_bud": 1,
        "sculk_sensor": 1,
        "sculk_catalyst": 6,
        "ochre_froglight": 15,
        "verdant_froglight": 15,
        "pearlescent_froglight": 15
    },
    "noOcclusions": {
        "mangrove_roots": true,
        "oak_leaves": true,
        "spruce_leaves": true,
        "birch_leaves": true,
        "jungle_leaves": true,
        "acacia_leaves": true,
        "cherry_leaves": true,
        "dark_oak_leaves": true,
        "mangrove_leaves": true,
        "azalea_leaves": true,
        "flowering_azalea_leaves": true,
        "glass": true,
        "white_bed": true,
        "orange_bed": true,
        "magenta_bed": true,
        "light_blue_bed": true,
        "yellow_bed": true,
        "lime_bed": true,
        "pink_bed": true,
        "gray_bed": true,
        "light_gray_bed": true,
        "cyan_bed": true,
        "purple_bed": true,
        "blue_bed": true,
        "brown_bed": true,
        "green_bed": true,
        "red_bed": true,
        "black_bed": true,
        "moving_piston": true,
        "spawner": true,
        "oak_door": true,
        "ladder": true,
        "iron_door": true,
        "ice": true,
        "white_stained_glass": true,
        "orange_stained_glass": true,
        "magenta_stained_glass": true,
        "light_blue_stained_glass": true,
        "yellow_stained_glass": true,
        "lime_stained_glass": true,
        "pink_stained_glass": true,
        "gray_stained_glass": true,
        "light_gray_stained_glass": true,
        "cyan_stained_glass": true,
        "purple_stained_glass": true,
        "blue_stained_glass": true,
        "brown_stained_glass": true,
        "green_stained_glass": true,
        "red_stained_glass": true,
        "black_stained_glass": true,
        "oak_trapdoor": true,
        "spruce_trapdoor": true,
        "birch_trapdoor": true,
        "jungle_trapdoor": true,
        "acacia_trapdoor": true,
        "cherry_trapdoor": true,
        "dark_oak_trapdoor": true,
        "mangrove_trapdoor": true,
        "bamboo_trapdoor": true,
        "iron_bars": true,
        "chain": true,
        "glass_pane": true,
        "lily_pad": true,
        "brewing_stand": true,
        "cauldron": true,
        "dragon_egg": true,
        "cocoa": true,
        "beacon": true,
        "hopper": true,
        "white_stained_glass_pane": true,
        "orange_stained_glass_pane": true,
        "magenta_stained_glass_pane": true,
        "light_blue_stained_glass_pane": true,
        "yellow_stained_glass_pane": true,
        "lime_stained_glass_pane": true,
        "pink_stained_glass_pane": true,
        "gray_stained_glass_pane": true,
        "light_gray_stained_glass_pane": true,
        "cyan_stained_glass_pane": true,
        "purple_stained_glass_pane": true,
        "blue_stained_glass_pane": true,
        "brown_stained_glass_pane": true,
        "green_stained_glass_pane": true,
        "red_stained_glass_pane": true,
        "black_stained_glass_pane": true,
        "slime_block": true,
        "barrier": true,
        "light": true,
        "iron_trapdoor": true,
        "spruce_door": true,
        "birch_door": true,
        "jungle_door": true,
        "acacia_door": true,
        "cherry_door": true,
        "dark_oak_door": true,
        "mangrove_door": true,
        "bamboo_door": true,
        "end_rod": true,
        "chorus_plant": true,
        "chorus_flower": true,
        "frosted_ice": true,
        "turtle_egg": true,
        "sniffer_egg": true,
        "sea_pickle": true,
        "conduit": true,
        "bamboo": true,
        "lantern": true,
        "soul_lantern": true,
        "campfire": true,
        "soul_campfire": true,
        "crimson_trapdoor": true,
        "warped_trapdoor": true,
        "crimson_door": true,
        "warped_door": true,
        "honey_block": true,
        "candle": true,
        "white_candle": true,
        "orange_candle": true,
        "magenta_candle": true,
        "light_blue_candle": true,
        "yellow_candle": true,
        "lime_candle": true,
        "pink_candle": true,
        "gray_candle": true,
        "light_gray_candle": true,
        "cyan_candle": true,
        "purple_candle": true,
        "blue_candle": true,
        "brown_candle": true,
        "green_candle": true,
        "red_candle": true,
        "black_candle": true,
        "amethyst_cluster": true,
        "tinted_glass": true,
        "lightning_rod": true,
        "pointed_dripstone": true,
        "azalea": true,
        "flowering_azalea": true,
        "frogspawn": true,
        "decorated_pot": true
    },
    "colors": {
        "stone": "rgb(112, 112, 112)",
        "granite": "rgb(151, 109, 77)",
        "polished_granite": "rgb(151, 109, 77)",
        "diorite": "rgb(255, 252, 245)",
        "polished_diorite": "rgb(255, 252, 245)",
        "andesite": "rgb(112, 112, 112)",
        "polished_andesite": "rgb(112, 112, 112)",
        "grass_block": "rgb(127, 178, 56)",
        "dirt": "rgb(151, 109, 77)",
        "coarse_dirt": "rgb(151, 109, 77)",
        "podzol": "rgb(129, 86, 49)",
        "cobblestone": "rgb(112, 112, 112)",
        "oak_planks": "rgb(143, 119, 72)",
        "spruce_planks": "rgb(129, 86, 49)",
        "birch_planks": "rgb(247, 233, 163)",
        "jungle_planks": "rgb(151, 109, 77)",
        "acacia_planks": "rgb(216, 127, 51)",
        "cherry_planks": "rgb(209, 177, 161)",
        "dark_oak_planks": "rgb(102, 76, 51)",
        "mangrove_planks": "rgb(153, 51, 51)",
        "bamboo_planks": "rgb(229, 229, 51)",
        "bamboo_mosaic": "rgb(229, 229, 51)",
        "oak_sapling": "rgb(0, 124, 0)",
        "spruce_sapling": "rgb(0, 124, 0)",
        "birch_sapling": "rgb(0, 124, 0)",
        "jungle_sapling": "rgb(0, 124, 0)",
        "acacia_sapling": "rgb(0, 124, 0)",
        "cherry_sapling": "rgb(242, 127, 165)",
        "dark_oak_sapling": "rgb(0, 124, 0)",
        "mangrove_propagule": "rgb(0, 124, 0)",
        "bedrock": "rgb(112, 112, 112)",
        "water": "rgb(64, 64, 255)",
        "lava": "rgb(255, 0, 0)",
        "sand": "rgb(247, 233, 163)",
        "suspicious_sand": "rgb(247, 233, 163)",
        "red_sand": "rgb(216, 127, 51)",
        "gravel": "rgb(112, 112, 112)",
        "suspicious_gravel": "rgb(112, 112, 112)",
        "gold_ore": "rgb(112, 112, 112)",
        "deepslate_gold_ore": "rgb(100, 100, 100)",
        "iron_ore": "rgb(112, 112, 112)",
        "deepslate_iron_ore": "rgb(100, 100, 100)",
        "coal_ore": "rgb(112, 112, 112)",
        "deepslate_coal_ore": "rgb(100, 100, 100)",
        "nether_gold_ore": "rgb(112, 2, 0)",
        "mangrove_roots": "rgb(129, 86, 49)",
        "muddy_mangrove_roots": "rgb(129, 86, 49)",
        "oak_wood": "rgb(143, 119, 72)",
        "spruce_wood": "rgb(129, 86, 49)",
        "birch_wood": "rgb(247, 233, 163)",
        "jungle_wood": "rgb(151, 109, 77)",
        "acacia_wood": "rgb(76, 76, 76)",
        "cherry_wood": "rgb(57, 41, 35)",
        "dark_oak_wood": "rgb(102, 76, 51)",
        "mangrove_wood": "rgb(153, 51, 51)",
        "stripped_oak_wood": "rgb(143, 119, 72)",
        "stripped_spruce_wood": "rgb(129, 86, 49)",
        "stripped_birch_wood": "rgb(247, 233, 163)",
        "stripped_jungle_wood": "rgb(151, 109, 77)",
        "stripped_acacia_wood": "rgb(216, 127, 51)",
        "stripped_cherry_wood": "rgb(160, 77, 78)",
        "stripped_dark_oak_wood": "rgb(102, 76, 51)",
        "oak_leaves": "rgb(0, 124, 0)",
        "spruce_leaves": "rgb(0, 124, 0)",
        "birch_leaves": "rgb(0, 124, 0)",
        "jungle_leaves": "rgb(0, 124, 0)",
        "acacia_leaves": "rgb(0, 124, 0)",
        "cherry_leaves": "rgb(242, 127, 165)",
        "dark_oak_leaves": "rgb(0, 124, 0)",
        "mangrove_leaves": "rgb(0, 124, 0)",
        "azalea_leaves": "rgb(0, 124, 0)",
        "flowering_azalea_leaves": "rgb(0, 124, 0)",
        "sponge": "rgb(229, 229, 51)",
        "wet_sponge": "rgb(229, 229, 51)",
        "lapis_ore": "rgb(112, 112, 112)",
        "deepslate_lapis_ore": "rgb(100, 100, 100)",
        "lapis_block": "rgb(74, 128, 255)",
        "dispenser": "rgb(112, 112, 112)",
        "sandstone": "rgb(247, 233, 163)",
        "chiseled_sandstone": "rgb(247, 233, 163)",
        "cut_sandstone": "rgb(247, 233, 163)",
        "note_block": "rgb(143, 119, 72)",
        "sticky_piston": "rgb(112, 112, 112)",
        "cobweb": "rgb(199, 199, 199)",
        "grass": "rgb(0, 124, 0)",
        "fern": "rgb(0, 124, 0)",
        "dead_bush": "rgb(143, 119, 72)",
        "seagrass": "rgb(64, 64, 255)",
        "tall_seagrass": "rgb(64, 64, 255)",
        "piston": "rgb(112, 112, 112)",
        "piston_head": "rgb(112, 112, 112)",
        "white_wool": "rgb(255, 255, 255)",
        "orange_wool": "rgb(216, 127, 51)",
        "magenta_wool": "rgb(178, 76, 216)",
        "light_blue_wool": "rgb(102, 153, 216)",
        "yellow_wool": "rgb(229, 229, 51)",
        "lime_wool": "rgb(127, 204, 25)",
        "pink_wool": "rgb(242, 127, 165)",
        "gray_wool": "rgb(76, 76, 76)",
        "light_gray_wool": "rgb(153, 153, 153)",
        "cyan_wool": "rgb(76, 127, 153)",
        "purple_wool": "rgb(127, 63, 178)",
        "blue_wool": "rgb(51, 76, 178)",
        "brown_wool": "rgb(102, 76, 51)",
        "green_wool": "rgb(102, 127, 51)",
        "red_wool": "rgb(153, 51, 51)",
        "black_wool": "rgb(25, 25, 25)",
        "moving_piston": "rgb(112, 112, 112)",
        "dandelion": "rgb(0, 124, 0)",
        "torchflower": "rgb(0, 124, 0)",
        "poppy": "rgb(0, 124, 0)",
        "blue_orchid": "rgb(0, 124, 0)",
        "allium": "rgb(0, 124, 0)",
        "azure_bluet": "rgb(0, 124, 0)",
        "red_tulip": "rgb(0, 124, 0)",
        "orange_tulip": "rgb(0, 124, 0)",
        "white_tulip": "rgb(0, 124, 0)",
        "pink_tulip": "rgb(0, 124, 0)",
        "oxeye_daisy": "rgb(0, 124, 0)",
        "cornflower": "rgb(0, 124, 0)",
        "wither_rose": "rgb(0, 124, 0)",
        "lily_of_the_valley": "rgb(0, 124, 0)",
        "brown_mushroom": "rgb(102, 76, 51)",
        "red_mushroom": "rgb(153, 51, 51)",
        "gold_block": "rgb(250, 238, 77)",
        "iron_block": "rgb(167, 167, 167)",
        "bricks": "rgb(153, 51, 51)",
        "tnt": "rgb(255, 0, 0)",
        "bookshelf": "rgb(143, 119, 72)",
        "chiseled_bookshelf": "rgb(143, 119, 72)",
        "mossy_cobblestone": "rgb(112, 112, 112)",
        "obsidian": "rgb(25, 25, 25)",
        "fire": "rgb(255, 0, 0)",
        "soul_fire": "rgb(102, 153, 216)",
        "spawner": "rgb(112, 112, 112)",
        "chest": "rgb(143, 119, 72)",
        "diamond_ore": "rgb(112, 112, 112)",
        "deepslate_diamond_ore": "rgb(100, 100, 100)",
        "diamond_block": "rgb(92, 219, 213)",
        "crafting_table": "rgb(143, 119, 72)",
        "wheat": "rgb(0, 124, 0)",
        "farmland": "rgb(151, 109, 77)",
        "furnace": "rgb(112, 112, 112)",
        "oak_sign": "rgb(143, 119, 72)",
        "birch_sign": "rgb(247, 233, 163)",
        "acacia_sign": "rgb(216, 127, 51)",
        "oak_wall_sign": "rgb(143, 119, 72)",
        "birch_wall_sign": "rgb(247, 233, 163)",
        "acacia_wall_sign": "rgb(216, 127, 51)",
        "birch_hanging_sign": "rgb(247, 233, 163)",
        "acacia_hanging_sign": "rgb(216, 127, 51)",
        "cherry_hanging_sign": "rgb(160, 77, 78)",
        "crimson_hanging_sign": "rgb(148, 63, 97)",
        "warped_hanging_sign": "rgb(58, 142, 140)",
        "bamboo_hanging_sign": "rgb(229, 229, 51)",
        "spruce_wall_hanging_sign": "rgb(143, 119, 72)",
        "birch_wall_hanging_sign": "rgb(247, 233, 163)",
        "acacia_wall_hanging_sign": "rgb(216, 127, 51)",
        "cherry_wall_hanging_sign": "rgb(160, 77, 78)",
        "crimson_wall_hanging_sign": "rgb(148, 63, 97)",
        "warped_wall_hanging_sign": "rgb(58, 142, 140)",
        "bamboo_wall_hanging_sign": "rgb(229, 229, 51)",
        "stone_pressure_plate": "rgb(112, 112, 112)",
        "iron_door": "rgb(167, 167, 167)",
        "redstone_ore": "rgb(112, 112, 112)",
        "deepslate_redstone_ore": "rgb(100, 100, 100)",
        "snow": "rgb(255, 255, 255)",
        "ice": "rgb(160, 160, 255)",
        "snow_block": "rgb(255, 255, 255)",
        "cactus": "rgb(0, 124, 0)",
        "clay": "rgb(164, 168, 184)",
        "sugar_cane": "rgb(0, 124, 0)",
        "jukebox": "rgb(151, 109, 77)",
        "pumpkin": "rgb(216, 127, 51)",
        "netherrack": "rgb(112, 2, 0)",
        "soul_sand": "rgb(102, 76, 51)",
        "soul_soil": "rgb(102, 76, 51)",
        "basalt": "rgb(25, 25, 25)",
        "polished_basalt": "rgb(25, 25, 25)",
        "glowstone": "rgb(247, 233, 163)",
        "carved_pumpkin": "rgb(216, 127, 51)",
        "jack_o_lantern": "rgb(216, 127, 51)",
        "oak_trapdoor": "rgb(143, 119, 72)",
        "spruce_trapdoor": "rgb(129, 86, 49)",
        "birch_trapdoor": "rgb(247, 233, 163)",
        "jungle_trapdoor": "rgb(151, 109, 77)",
        "acacia_trapdoor": "rgb(216, 127, 51)",
        "cherry_trapdoor": "rgb(209, 177, 161)",
        "dark_oak_trapdoor": "rgb(102, 76, 51)",
        "mangrove_trapdoor": "rgb(153, 51, 51)",
        "bamboo_trapdoor": "rgb(229, 229, 51)",
        "stone_bricks": "rgb(112, 112, 112)",
        "mossy_stone_bricks": "rgb(112, 112, 112)",
        "cracked_stone_bricks": "rgb(112, 112, 112)",
        "chiseled_stone_bricks": "rgb(112, 112, 112)",
        "mud_bricks": "rgb(135, 107, 98)",
        "infested_stone": "rgb(164, 168, 184)",
        "infested_cobblestone": "rgb(164, 168, 184)",
        "infested_stone_bricks": "rgb(164, 168, 184)",
        "infested_mossy_stone_bricks": "rgb(164, 168, 184)",
        "infested_cracked_stone_bricks": "rgb(164, 168, 184)",
        "infested_chiseled_stone_bricks": "rgb(164, 168, 184)",
        "brown_mushroom_block": "rgb(151, 109, 77)",
        "red_mushroom_block": "rgb(153, 51, 51)",
        "mushroom_stem": "rgb(199, 199, 199)",
        "melon": "rgb(127, 204, 25)",
        "attached_pumpkin_stem": "rgb(0, 124, 0)",
        "attached_melon_stem": "rgb(0, 124, 0)",
        "pumpkin_stem": "rgb(0, 124, 0)",
        "melon_stem": "rgb(0, 124, 0)",
        "vine": "rgb(0, 124, 0)",
        "glow_lichen": "rgb(127, 167, 150)",
        "mycelium": "rgb(127, 63, 178)",
        "lily_pad": "rgb(0, 124, 0)",
        "nether_bricks": "rgb(112, 2, 0)",
        "nether_brick_fence": "rgb(112, 2, 0)",
        "nether_wart": "rgb(153, 51, 51)",
        "enchanting_table": "rgb(153, 51, 51)",
        "brewing_stand": "rgb(167, 167, 167)",
        "cauldron": "rgb(112, 112, 112)",
        "end_portal": "rgb(25, 25, 25)",
        "end_portal_frame": "rgb(102, 127, 51)",
        "end_stone": "rgb(247, 233, 163)",
        "dragon_egg": "rgb(25, 25, 25)",
        "cocoa": "rgb(0, 124, 0)",
        "emerald_ore": "rgb(112, 112, 112)",
        "deepslate_emerald_ore": "rgb(100, 100, 100)",
        "ender_chest": "rgb(112, 112, 112)",
        "emerald_block": "rgb(0, 217, 58)",
        "command_block": "rgb(102, 76, 51)",
        "beacon": "rgb(92, 219, 213)",
        "carrots": "rgb(0, 124, 0)",
        "potatoes": "rgb(0, 124, 0)",
        "anvil": "rgb(167, 167, 167)",
        "chipped_anvil": "rgb(167, 167, 167)",
        "damaged_anvil": "rgb(167, 167, 167)",
        "trapped_chest": "rgb(143, 119, 72)",
        "light_weighted_pressure_plate": "rgb(250, 238, 77)",
        "heavy_weighted_pressure_plate": "rgb(167, 167, 167)",
        "daylight_detector": "rgb(143, 119, 72)",
        "redstone_block": "rgb(255, 0, 0)",
        "nether_quartz_ore": "rgb(112, 2, 0)",
        "hopper": "rgb(112, 112, 112)",
        "quartz_block": "rgb(255, 252, 245)",
        "chiseled_quartz_block": "rgb(255, 252, 245)",
        "quartz_pillar": "rgb(255, 252, 245)",
        "dropper": "rgb(112, 112, 112)",
        "white_terracotta": "rgb(209, 177, 161)",
        "orange_terracotta": "rgb(159, 82, 36)",
        "magenta_terracotta": "rgb(149, 87, 108)",
        "light_blue_terracotta": "rgb(112, 108, 138)",
        "yellow_terracotta": "rgb(186, 133, 36)",
        "lime_terracotta": "rgb(103, 117, 53)",
        "pink_terracotta": "rgb(160, 77, 78)",
        "gray_terracotta": "rgb(57, 41, 35)",
        "light_gray_terracotta": "rgb(135, 107, 98)",
        "cyan_terracotta": "rgb(87, 92, 92)",
        "purple_terracotta": "rgb(122, 73, 88)",
        "blue_terracotta": "rgb(76, 62, 92)",
        "brown_terracotta": "rgb(76, 50, 35)",
        "green_terracotta": "rgb(76, 82, 42)",
        "red_terracotta": "rgb(142, 60, 46)",
        "black_terracotta": "rgb(37, 22, 16)",
        "slime_block": "rgb(127, 178, 56)",
        "iron_trapdoor": "rgb(167, 167, 167)",
        "prismarine": "rgb(76, 127, 153)",
        "prismarine_bricks": "rgb(92, 219, 213)",
        "dark_prismarine": "rgb(92, 219, 213)",
        "prismarine_slab": "rgb(76, 127, 153)",
        "prismarine_brick_slab": "rgb(92, 219, 213)",
        "dark_prismarine_slab": "rgb(92, 219, 213)",
        "sea_lantern": "rgb(255, 252, 245)",
        "hay_block": "rgb(229, 229, 51)",
        "white_carpet": "rgb(255, 255, 255)",
        "orange_carpet": "rgb(216, 127, 51)",
        "magenta_carpet": "rgb(178, 76, 216)",
        "light_blue_carpet": "rgb(102, 153, 216)",
        "yellow_carpet": "rgb(229, 229, 51)",
        "lime_carpet": "rgb(127, 204, 25)",
        "pink_carpet": "rgb(242, 127, 165)",
        "gray_carpet": "rgb(76, 76, 76)",
        "light_gray_carpet": "rgb(153, 153, 153)",
        "cyan_carpet": "rgb(76, 127, 153)",
        "purple_carpet": "rgb(127, 63, 178)",
        "blue_carpet": "rgb(51, 76, 178)",
        "brown_carpet": "rgb(102, 76, 51)",
        "green_carpet": "rgb(102, 127, 51)",
        "red_carpet": "rgb(153, 51, 51)",
        "black_carpet": "rgb(25, 25, 25)",
        "terracotta": "rgb(216, 127, 51)",
        "coal_block": "rgb(25, 25, 25)",
        "packed_ice": "rgb(160, 160, 255)",
        "sunflower": "rgb(0, 124, 0)",
        "lilac": "rgb(0, 124, 0)",
        "rose_bush": "rgb(0, 124, 0)",
        "peony": "rgb(0, 124, 0)",
        "tall_grass": "rgb(0, 124, 0)",
        "large_fern": "rgb(0, 124, 0)",
        "white_banner": "rgb(143, 119, 72)",
        "orange_banner": "rgb(143, 119, 72)",
        "magenta_banner": "rgb(143, 119, 72)",
        "light_blue_banner": "rgb(143, 119, 72)",
        "yellow_banner": "rgb(143, 119, 72)",
        "lime_banner": "rgb(143, 119, 72)",
        "pink_banner": "rgb(143, 119, 72)",
        "gray_banner": "rgb(143, 119, 72)",
        "light_gray_banner": "rgb(143, 119, 72)",
        "cyan_banner": "rgb(143, 119, 72)",
        "purple_banner": "rgb(143, 119, 72)",
        "blue_banner": "rgb(143, 119, 72)",
        "brown_banner": "rgb(143, 119, 72)",
        "green_banner": "rgb(143, 119, 72)",
        "red_banner": "rgb(143, 119, 72)",
        "black_banner": "rgb(143, 119, 72)",
        "white_wall_banner": "rgb(143, 119, 72)",
        "orange_wall_banner": "rgb(143, 119, 72)",
        "magenta_wall_banner": "rgb(143, 119, 72)",
        "light_blue_wall_banner": "rgb(143, 119, 72)",
        "yellow_wall_banner": "rgb(143, 119, 72)",
        "lime_wall_banner": "rgb(143, 119, 72)",
        "pink_wall_banner": "rgb(143, 119, 72)",
        "gray_wall_banner": "rgb(143, 119, 72)",
        "light_gray_wall_banner": "rgb(143, 119, 72)",
        "cyan_wall_banner": "rgb(143, 119, 72)",
        "purple_wall_banner": "rgb(143, 119, 72)",
        "blue_wall_banner": "rgb(143, 119, 72)",
        "brown_wall_banner": "rgb(143, 119, 72)",
        "green_wall_banner": "rgb(143, 119, 72)",
        "red_wall_banner": "rgb(143, 119, 72)",
        "black_wall_banner": "rgb(143, 119, 72)",
        "red_sandstone": "rgb(216, 127, 51)",
        "chiseled_red_sandstone": "rgb(216, 127, 51)",
        "cut_red_sandstone": "rgb(216, 127, 51)",
        "oak_slab": "rgb(143, 119, 72)",
        "spruce_slab": "rgb(129, 86, 49)",
        "birch_slab": "rgb(247, 233, 163)",
        "jungle_slab": "rgb(151, 109, 77)",
        "acacia_slab": "rgb(216, 127, 51)",
        "cherry_slab": "rgb(209, 177, 161)",
        "dark_oak_slab": "rgb(102, 76, 51)",
        "mangrove_slab": "rgb(153, 51, 51)",
        "bamboo_slab": "rgb(229, 229, 51)",
        "bamboo_mosaic_slab": "rgb(229, 229, 51)",
        "stone_slab": "rgb(112, 112, 112)",
        "smooth_stone_slab": "rgb(112, 112, 112)",
        "sandstone_slab": "rgb(247, 233, 163)",
        "cut_sandstone_slab": "rgb(247, 233, 163)",
        "petrified_oak_slab": "rgb(143, 119, 72)",
        "cobblestone_slab": "rgb(112, 112, 112)",
        "brick_slab": "rgb(153, 51, 51)",
        "stone_brick_slab": "rgb(112, 112, 112)",
        "mud_brick_slab": "rgb(135, 107, 98)",
        "nether_brick_slab": "rgb(112, 2, 0)",
        "quartz_slab": "rgb(255, 252, 245)",
        "red_sandstone_slab": "rgb(216, 127, 51)",
        "cut_red_sandstone_slab": "rgb(216, 127, 51)",
        "purpur_slab": "rgb(178, 76, 216)",
        "smooth_stone": "rgb(112, 112, 112)",
        "smooth_sandstone": "rgb(247, 233, 163)",
        "smooth_quartz": "rgb(255, 252, 245)",
        "smooth_red_sandstone": "rgb(216, 127, 51)",
        "chorus_plant": "rgb(127, 63, 178)",
        "chorus_flower": "rgb(127, 63, 178)",
        "purpur_block": "rgb(178, 76, 216)",
        "purpur_pillar": "rgb(178, 76, 216)",
        "end_stone_bricks": "rgb(247, 233, 163)",
        "torchflower_crop": "rgb(0, 124, 0)",
        "pitcher_crop": "rgb(0, 124, 0)",
        "pitcher_plant": "rgb(0, 124, 0)",
        "beetroots": "rgb(0, 124, 0)",
        "dirt_path": "rgb(151, 109, 77)",
        "end_gateway": "rgb(25, 25, 25)",
        "repeating_command_block": "rgb(127, 63, 178)",
        "chain_command_block": "rgb(102, 127, 51)",
        "frosted_ice": "rgb(160, 160, 255)",
        "magma_block": "rgb(112, 2, 0)",
        "nether_wart_block": "rgb(153, 51, 51)",
        "red_nether_bricks": "rgb(112, 2, 0)",
        "bone_block": "rgb(247, 233, 163)",
        "observer": "rgb(112, 112, 112)",
        "kelp": "rgb(64, 64, 255)",
        "kelp_plant": "rgb(64, 64, 255)",
        "dried_kelp_block": "rgb(102, 127, 51)",
        "turtle_egg": "rgb(247, 233, 163)",
        "sniffer_egg": "rgb(153, 51, 51)",
        "dead_tube_coral_block": "rgb(76, 76, 76)",
        "dead_brain_coral_block": "rgb(76, 76, 76)",
        "dead_bubble_coral_block": "rgb(76, 76, 76)",
        "dead_fire_coral_block": "rgb(76, 76, 76)",
        "dead_horn_coral_block": "rgb(76, 76, 76)",
        "tube_coral_block": "rgb(51, 76, 178)",
        "brain_coral_block": "rgb(242, 127, 165)",
        "bubble_coral_block": "rgb(127, 63, 178)",
        "fire_coral_block": "rgb(153, 51, 51)",
        "horn_coral_block": "rgb(229, 229, 51)",
        "dead_tube_coral": "rgb(76, 76, 76)",
        "dead_brain_coral": "rgb(76, 76, 76)",
        "dead_bubble_coral": "rgb(76, 76, 76)",
        "dead_fire_coral": "rgb(76, 76, 76)",
        "dead_horn_coral": "rgb(76, 76, 76)",
        "tube_coral": "rgb(51, 76, 178)",
        "brain_coral": "rgb(242, 127, 165)",
        "bubble_coral": "rgb(127, 63, 178)",
        "fire_coral": "rgb(153, 51, 51)",
        "horn_coral": "rgb(229, 229, 51)",
        "dead_tube_coral_fan": "rgb(76, 76, 76)",
        "dead_brain_coral_fan": "rgb(76, 76, 76)",
        "dead_bubble_coral_fan": "rgb(76, 76, 76)",
        "dead_fire_coral_fan": "rgb(76, 76, 76)",
        "dead_horn_coral_fan": "rgb(76, 76, 76)",
        "tube_coral_fan": "rgb(51, 76, 178)",
        "brain_coral_fan": "rgb(242, 127, 165)",
        "bubble_coral_fan": "rgb(127, 63, 178)",
        "fire_coral_fan": "rgb(153, 51, 51)",
        "horn_coral_fan": "rgb(229, 229, 51)",
        "dead_tube_coral_wall_fan": "rgb(76, 76, 76)",
        "dead_brain_coral_wall_fan": "rgb(76, 76, 76)",
        "dead_bubble_coral_wall_fan": "rgb(76, 76, 76)",
        "dead_fire_coral_wall_fan": "rgb(76, 76, 76)",
        "dead_horn_coral_wall_fan": "rgb(76, 76, 76)",
        "tube_coral_wall_fan": "rgb(51, 76, 178)",
        "brain_coral_wall_fan": "rgb(242, 127, 165)",
        "bubble_coral_wall_fan": "rgb(127, 63, 178)",
        "fire_coral_wall_fan": "rgb(153, 51, 51)",
        "horn_coral_wall_fan": "rgb(229, 229, 51)",
        "sea_pickle": "rgb(102, 127, 51)",
        "blue_ice": "rgb(160, 160, 255)",
        "conduit": "rgb(92, 219, 213)",
        "bamboo_sapling": "rgb(143, 119, 72)",
        "bamboo": "rgb(0, 124, 0)",
        "bubble_column": "rgb(64, 64, 255)",
        "scaffolding": "rgb(247, 233, 163)",
        "loom": "rgb(143, 119, 72)",
        "barrel": "rgb(143, 119, 72)",
        "smoker": "rgb(112, 112, 112)",
        "blast_furnace": "rgb(112, 112, 112)",
        "cartography_table": "rgb(143, 119, 72)",
        "fletching_table": "rgb(143, 119, 72)",
        "grindstone": "rgb(167, 167, 167)",
        "lectern": "rgb(143, 119, 72)",
        "smithing_table": "rgb(143, 119, 72)",
        "stonecutter": "rgb(112, 112, 112)",
        "bell": "rgb(250, 238, 77)",
        "lantern": "rgb(167, 167, 167)",
        "soul_lantern": "rgb(167, 167, 167)",
        "campfire": "rgb(129, 86, 49)",
        "soul_campfire": "rgb(129, 86, 49)",
        "sweet_berry_bush": "rgb(0, 124, 0)",
        "warped_hyphae": "rgb(86, 44, 62)",
        "stripped_warped_hyphae": "rgb(86, 44, 62)",
        "warped_nylium": "rgb(22, 126, 134)",
        "warped_fungus": "rgb(76, 127, 153)",
        "warped_wart_block": "rgb(20, 180, 133)",
        "warped_roots": "rgb(76, 127, 153)",
        "nether_sprouts": "rgb(76, 127, 153)",
        "crimson_hyphae": "rgb(92, 25, 29)",
        "stripped_crimson_hyphae": "rgb(92, 25, 29)",
        "crimson_nylium": "rgb(189, 48, 49)",
        "crimson_fungus": "rgb(112, 2, 0)",
        "shroomlight": "rgb(153, 51, 51)",
        "weeping_vines": "rgb(112, 2, 0)",
        "weeping_vines_plant": "rgb(112, 2, 0)",
        "twisting_vines": "rgb(76, 127, 153)",
        "twisting_vines_plant": "rgb(76, 127, 153)",
        "crimson_roots": "rgb(112, 2, 0)",
        "crimson_planks": "rgb(148, 63, 97)",
        "warped_planks": "rgb(58, 142, 140)",
        "structure_block": "rgb(153, 153, 153)",
        "jigsaw": "rgb(153, 153, 153)",
        "composter": "rgb(143, 119, 72)",
        "target": "rgb(255, 252, 245)",
        "bee_nest": "rgb(229, 229, 51)",
        "beehive": "rgb(143, 119, 72)",
        "honey_block": "rgb(216, 127, 51)",
        "honeycomb_block": "rgb(216, 127, 51)",
        "netherite_block": "rgb(25, 25, 25)",
        "ancient_debris": "rgb(25, 25, 25)",
        "crying_obsidian": "rgb(25, 25, 25)",
        "respawn_anchor": "rgb(25, 25, 25)",
        "lodestone": "rgb(167, 167, 167)",
        "blackstone": "rgb(25, 25, 25)",
        "polished_blackstone_pressure_plate": "rgb(25, 25, 25)",
        "chiseled_nether_bricks": "rgb(112, 2, 0)",
        "cracked_nether_bricks": "rgb(112, 2, 0)",
        "amethyst_block": "rgb(127, 63, 178)",
        "budding_amethyst": "rgb(127, 63, 178)",
        "amethyst_cluster": "rgb(127, 63, 178)",
        "tuff": "rgb(57, 41, 35)",
        "calcite": "rgb(209, 177, 161)",
        "tinted_glass": "rgb(76, 76, 76)",
        "powder_snow": "rgb(255, 255, 255)",
        "sculk_sensor": "rgb(76, 127, 153)",
        "sculk": "rgb(25, 25, 25)",
        "sculk_vein": "rgb(25, 25, 25)",
        "sculk_catalyst": "rgb(25, 25, 25)",
        "sculk_shrieker": "rgb(25, 25, 25)",
        "oxidized_copper": "rgb(22, 126, 134)",
        "weathered_copper": "rgb(58, 142, 140)",
        "exposed_copper": "rgb(135, 107, 98)",
        "copper_block": "rgb(216, 127, 51)",
        "deepslate_copper_ore": "rgb(100, 100, 100)",
        "lightning_rod": "rgb(216, 127, 51)",
        "pointed_dripstone": "rgb(76, 50, 35)",
        "dripstone_block": "rgb(76, 50, 35)",
        "cave_vines": "rgb(0, 124, 0)",
        "cave_vines_plant": "rgb(0, 124, 0)",
        "spore_blossom": "rgb(0, 124, 0)",
        "azalea": "rgb(0, 124, 0)",
        "flowering_azalea": "rgb(0, 124, 0)",
        "moss_carpet": "rgb(102, 127, 51)",
        "pink_petals": "rgb(0, 124, 0)",
        "moss_block": "rgb(102, 127, 51)",
        "big_dripleaf": "rgb(0, 124, 0)",
        "big_dripleaf_stem": "rgb(0, 124, 0)",
        "small_dripleaf": "rgb(0, 124, 0)",
        "hanging_roots": "rgb(151, 109, 77)",
        "rooted_dirt": "rgb(151, 109, 77)",
        "mud": "rgb(87, 92, 92)",
        "deepslate": "rgb(100, 100, 100)",
        "infested_deepslate": "rgb(100, 100, 100)",
        "raw_iron_block": "rgb(216, 175, 147)",
        "raw_copper_block": "rgb(216, 127, 51)",
        "raw_gold_block": "rgb(250, 238, 77)",
        "ochre_froglight": "rgb(247, 233, 163)",
        "verdant_froglight": "rgb(127, 167, 150)",
        "pearlescent_froglight": "rgb(242, 127, 165)",
        "frogspawn": "rgb(64, 64, 255)",
        "reinforced_deepslate": "rgb(100, 100, 100)",
        "decorated_pot": "rgb(142, 60, 46)"
    }
}
